import apiFetch from '../../../utils/apiFetch';
import { rollDiceWithBox } from '../../../utils/diceBoxManager';
import { fateBonus } from '../../../shared/rules/epicBoons.mjs';

/** Spends Improve Fate (Boon of Fate) on one d20 test made on the sheet, with the 2d4 rolled; the same requestId replays. */
export const claimFate = async (characterId, { requestId, kind, rolls }) => {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/boon-of-fate`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId, kind, rolls }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || 'Improve Fate could not be used.');
  return result;
};

/** The character with Improve Fate's new state, unless it already holds a newer one. */
export const withFate = (character, boonOfFate) => (character && boonOfFate
  && Number(boonOfFate.revision || 0) >= Number(character.boonOfFate?.revision || 0)
  ? { ...character, boonOfFate } : character);

const d4 = value => (Number.isInteger(value) && value >= 1 && value <= 4 ? value : Math.floor(Math.random() * 4) + 1);

/**
 * Improve Fate on a roll made on the sheet: rolls 2d4 in the dice box, spends it on the server with those dice and returns
 * `{ rolls, bonus }` (a replayed claim returns the dice stored with the first one).
 */
export async function spendFateOnRoll({ characterId, requestId, kind, onCharacterChange }) {
  const roll = await rollDiceWithBox([{ count: 2, sides: 4 }]).catch(() => null);
  const fresh = [d4(Number(roll?.rolls?.[0]?.[0])), d4(Number(roll?.rolls?.[0]?.[1]))];
  const claimed = await claimFate(characterId, { requestId, kind, rolls: fresh });
  onCharacterChange?.(previous => withFate(previous, claimed.boonOfFate));
  const rolls = Array.isArray(claimed.boonOfFate?.rolls) && claimed.boonOfFate.rolls.length === 2 ? claimed.boonOfFate.rolls : fresh;
  return { rolls, bonus: fateBonus(rolls) };
}
